import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import Vue from 'vue';
Vue.config.silent = true

import axios from "axios";
import VueMq from "vue-mq";
import Slick from "vue-slick";
import Collapsible from "./components/collapsible.vue";
import Cookie from "js-cookie";
import filter from "lodash-es/filter";
import 'lazysizes';
import 'lazysizes/plugins/rias/ls.rias';
import formatMoney from './utilities/formatMoney';
import getParamByName from './utilities/getParamByName';
import scrollToElement from './utilities/scrollToElement';
import { setCurrency } from './currency';
import { CountryProvinceSelector } from '@shopify/theme-addresses';
import { nextTick } from 'vue';
import { doPermalink } from './permalink';

doPermalink();

window.theme = window.theme || {};
window.theme.formatMoney = formatMoney;
window.theme.centsInCurrency = (cents, rate = Shopify.currency.rate) => {
  if (Shopify.currency.active === window.theme.shopCurrency) {
    return cents;
  }
  return (Math.ceil(cents * rate  / 100)) * 100;
};
window.theme.afterpayInstalmentsFromCents = cents => Math.round(cents / 4);
window.scrollToElement = scrollToElement;

window.theme.CountryProvinceSelector = CountryProvinceSelector;

const debounce = require("lodash/debounce");

import Transitions from "vue2-transitions";
Vue.use(Transitions);

// On click-outside
import { directive as onClickOutside } from "vue-on-click-outside";
Vue.directive("on-click-outside", onClickOutside);

import { Plugin } from 'vue-fragment';
Vue.use(Plugin);

// Set lazysizes load mode to fast onload event
lazySizes.cfg.expFactor = 4;

// Filters
import "./filters/currencyFromCents";
import "./filters/currencyWithoutCents";
import "./filters/replace";
import "./filters/currencyThePrice";
import "./filters/discount";
Vue.filter('centsInCurrency', (cents, rate) => theme.centsInCurrency(cents, rate));
Vue.filter('formatMoney', cents => theme.formatMoney(cents, theme.moneyFormat));
Vue.filter('money', cents => theme.formatMoney(cents, theme.moneyFormat));
Vue.filter('withCurrency', price => `${ price } ${ Shopify.currency.active }`);
Vue.filter('afterpayInstalmentsFromCents', cents => theme.afterpayInstalmentsFromCents(cents));

// import MaCode from "./components/ma-code.vue";

// Components with inline templates
import "./components/ma-app-out-of-stock";
import "./components/notify-me";
import "./components/my-wishlist";
import "./components/newsletter";
import "./components/product";

// Utilities
import { requestConfig } from "./utilities/storefront";

// Section-based configs
Vue.prototype.config = window.config;
Vue.prototype.theme = window.theme;
Vue.prototype.cart = window.theme.cart;
Vue.prototype.utils = window.utils;

// Global components
Vue.component("astro-toaster", require("./components/toaster.vue").default);
Vue.component(
  "shipping-rate",
  require("./components/shipping-rate.vue").default
);
Vue.component("accordion", require("./components/accordion.vue").default);
Vue.component('shipping_bar', require('./components/shipping_bar.vue').default);
Vue.component('shipping_progress_bar', require('./components/shipping_progress_bar.vue').default);
Vue.component('cart_items', require('./components/cart_items.vue').default);
Vue.component('cart_item', require('./components/cart_item.vue').default);
Vue.component('cart_item_upsell', require('./components/cart_item_upsell.vue').default);
Vue.component('cart_empty', require('./components/cart_empty.vue').default);
Vue.component('qty_adjuster', require('./components/qty_adjuster.vue').default);
Vue.component('cart_summary', require('./components/cart_summary.vue').default);
Vue.component('subscription_prefs_form', require('./components/subscription_prefs_form.vue').default);
Vue.component('birthday_nomination_form', require('./components/birthday_nomination_form.vue').default);
Vue.component('newsletter', require('./components/newsletter.vue').default);

Vue.component('product_badges', require('./components/product_badges.vue').default);
Vue.component('gift_card_selector', require('./components/gift_card_selector.vue').default);

// Component Packages
import { Tabs, Tab } from "vue-tabs-component";
Vue.component("tabs", Tabs);
Vue.component("tab", Tab);

Vue.use(VueMq, {
  breakpoints: {
    1: 576,
    2: 768,
    3: 992,
    4: 1200,
    5: Infinity
  }
});

export let app;

function initVueInstance() {
  app = new Vue({
    components: {
      Slick,
      Collapsible
    },

    el: "#app",

    delimiters: ["${", "}"],

    data: {
      shopCurrency: "",
      visitorInfo: null,
      isMenuOpen: false,
      isMegamenuOpen: {},
      isMinicartOpen: false,
      isSearchOpen: false,
      isCollectionDescriptionOpen: false,
      cart: false,
      cartLoaded: false,
      searchInput: "",
      currentTransition: "",
      instantSearch: null,
      siteName: "",
      internationalVisitor: false,
      storewideDiscount: window.theme.storewideDiscountEnable,
      searchChanging: false,
      frozen: false,
      dataVpos: false,
      overlayClasses: '',
      overlayCloseCallback: false,
      activeElement: "",
    },

    watch: {
      searchInput(val) {
        // Query search data from api
        if (val) {
          this.instantSearchQuery(val);
        }
      }
    },

    directives: {
      initMegamenu: {
        bind(el, binding, vnode) {
          let dropdown = document.querySelector(
            '[parent-item="' + binding.value + '"]'
          );
          el.addEventListener("mouseover", () => {
            if (vnode.context.$mq > 3) {
              vnode.context.closeAllMegamenus();
            }
          });
          // el.addEventListener("focusout", () => {
          //   if (vnode.context.$mq > 3) {
          //     vnode.context.closeAllMegamenus();
          //   }
          // });
          el.addEventListener("keydown", (e) => {
            if (e.keyCode !== 27) {
              return
            }
            
            if (vnode.context.$mq > 3) {
              vnode.context.closeAllMegamenus();
            }
          });
          if (dropdown) {
            Vue.set(vnode.context.isMegamenuOpen, binding.value, false);
            el.addEventListener("mouseover", e => {
              if (vnode.context.$mq > 3) {
                e.preventDefault();
                vnode.context.currentTransition = "fade";
                vnode.context.toggleMegamenu(binding.value);
              }
            });
            el.addEventListener("keydown", e => {
              if (e.keyCode !== 9 || (!e.shiftKey && e.keyCode !== 9)) {
                return;
              }

              const focusForward = !e.shiftKey

              if (vnode.context.$mq > 3) {
                vnode.context.currentTransition = "fade";

                if (focusForward) {
                  e.preventDefault();
                  vnode.context.toggleMegamenu(binding.value);
                } else {
                  vnode.context.closeAllMegamenus()
                }

                vnode.context.focusMegamenu(binding.value, el, focusForward)
              }
            });
            el.addEventListener("click", e => {
              if (vnode.context.$mq <= 3) {
                e.preventDefault();
                vnode.context.toggleMegamenu(binding.value);
              }
            });
          }
        },
        unbind(el) {
          el.removeEventListener("click");
          el.removeEventListener("keydown");
          el.removeEventListener("focusout");
        }
      }
    },

    methods: {
      freeze(frozen, vpos = false) {
        if (this.frozen && frozen) {
          return;
        }
        const wasVpos = this.dataVpos;
        this.frozen = frozen;
        this.dataVpos = vpos;
        if (!frozen) {
          // God knows why we need this timeout, but it works.
          setTimeout(() => {
            document.documentElement.scrollTop = wasVpos;  
          }, 1);
        }

      },

      overlayToggle(show, callback, showClass = '_show') {
        this.overlayClasses = show ? showClass : '';
        this.overlayCloseCallback = callback;
      },

      // this functions are related to instant search

      compare_at_price_max(item) {
        let activeCurrency =
          "compare_at_price_max_" + this.cart.currency.toLowerCase();
        return item[activeCurrency];
      },

      compare_at_price_min(item) {
        let activeCurrency =
          "compare_at_price_min_" + this.cart.currency.toLowerCase();
        return item[activeCurrency];
      },

      price_min(item) {
        let activeCurrency = "price_min_" + this.cart.currency.toLowerCase();
        return item[activeCurrency];
      },

      price_max(item) {
        let activeCurrency = "price_max_" + this.cart.currency.toLowerCase();
        return item[activeCurrency];
      },

      productLink(handle) {
        return "/products/" + handle;
      },

      handleReInit(event, slick) {
        console.log('handleReInit', event, slick);
      },

      focusChanged(e) {
        this.activeElement = e.target
      },

      reInit() {
        // Helpful if you have to deal with v-for to update dynamic lists
        this.$nextTick(() => {
          slick = document.querySelector("slick");
            this.$refs.slick.reSlick();
        });
      },

      // Using Boots app api to query search data
      // debounce will delay function call. (lodash/debounce)
      instantSearchQuery: debounce(function(query) {
        let host = document.location.hostname;

        if (host.includes(".au")) {
          host = "white-fox-boutique-aus.myshopify.com";
        }
        else if (host.includes("develop")) {
          host = "white-fox-boutique-develop.myshopify.com";
        }
        else {
          host = "white-fox-boutique-usa.myshopify.com";
        }
        let url = `https://services.mybcapps.com/bc-sf-filter/search/suggest?q=${query}&shop=${host}&product_limit=10&suggestion_limit=3&collection_limit=6&page_limit=3&dym_limit=2`;
        axios
          .get(url)
          .then(response => {
            this.instantSearch = response.data;
          })
          .catch(error => {
            console.log("Search API :", error);
          });
      }, 150),

      // redirect to checkout and update the currency too.

      goToCheckout(event) {
        event.target.classList.add("loading");

        let currentCurrency = Cookie.get("cart_currency");
        Cookie.set("userCurrency", currentCurrency, { expires: 7, path: "/" });
        Cookie.set("letUser", true, { expires: 7, path: "/" });
        axios
          .post("/cart/update.js", { currency: this.shopCurrency })
          .then(response => {
            window.location.href =
              document.location.protocol +
              "//" +
              document.location.hostname +
              "/checkout";
          })
          .catch(error => {
            console.log("Currency Error: ", error);
          });
      },

      // This function will be called on first time visit to website
      // for more info about the ip services. please visit : https://ipapi.co/#pricing
      // 30k request per month is free. We should go with paid plan on production
      /*
      checkUserCountry() {
        
          let domain = window.location.href;
          // default is US
          let key = "234e7953f201b9490be967c0a5a658f70b251da4";
          if (domain.includes(".au")) {
            key = "3196f482b5033d6a4ee7630e5adbeebc78fb0dc9";
          }
          
          if(!Cookie.get('visitorCountry')) {
            axios
              .get("https://ipapi.co/json/?key=" + key)
              .then(response => {
                this.visitorInfo = response.data;

                // Ticket WHIT2-979 to create redirect modal widow for users
                // US visitor country list

                let us_visitors = ['NA','SA'];
            
                // find a common similarity between visitor and store.
                // For US continants, I set it as "USD". 
                let visitorTempCurrency = "AUD";
                if(us_visitors.includes(this.visitorInfo.continent_code)){
                  visitorTempCurrency = "USD";
                }else if(this.visitorInfo.continent_code == 'OC'){
                  visitorTempCurrency = "AUD";
                }
                Cookie.set("visitorCountry", response.data, {
                  expires: 7,
                  path: "/"
                });

                // don't show modal if user country is the same as website location unless dev_mode is true
                if(visitorTempCurrency != this.shopCurrency){

                    // Canada and South America, USA territories/islands (e.g. Puerto rico etc.) 
                    // visiting AU store - Prompt to US store.  
                    if(visitorTempCurrency  == 'USD' && Shopify.shop == "white-fox-boutique-aus.myshopify.com"){
                      
                        $('#redirect-modal').addClass('show');
                        $('#redirect-modal').show();
                    }

                    // if Australian visitor visit US store
                    if(visitorTempCurrency == "AUD" && Shopify.shop == "white-fox-boutique-usa.myshopify.com"){

                      $('#redirect-modal').addClass('show');
                      $('#redirect-modal').show();
                    }
                }

              })
              .catch(error => {
                console.log("Error : ", error);
              });
            }
            else {
              let visitorData = JSON.parse(Cookie.get('visitorCountry'));
              this.visitorInfo = visitorData;
              let us_visitors = ['NA','SA'];
            
              // find a common similarity between visitor and store.
              // For US continants, I set it as "USD". 
              let visitorTempCurrency = "AUD";
              if(us_visitors.includes(visitorData.continent_code)){
                visitorTempCurrency = "USD";
              }else if(visitorData.continent_code == 'OC'){
                visitorTempCurrency = "AUD";
              }

              // don't show modal if user country is the same as website location unless dev_mode is true
              if(visitorTempCurrency != this.shopCurrency){

                // Canada and South America, USA territories/islands (e.g. Puerto rico etc.) 
                // visiting AU store - Prompt to US store.  
                if(visitorTempCurrency  == 'USD' && Shopify.shop == "white-fox-boutique-aus.myshopify.com"){
                  
                    $('#redirect-modal').addClass('show');
                    $('#redirect-modal').show();
                }

                // if Australian visitor visit US store
                if(visitorTempCurrency == "AUD" && Shopify.shop == "white-fox-boutique-usa.myshopify.com"){

                  $('#redirect-modal').addClass('show');
                  $('#redirect-modal').show();
                }
              }
            }
      },
      */

      // Return query string parameters value, searching by name
      getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      },
      vueSetCurrency(event) {
        event.preventDefault();
        event.stopPropagation();

        const value = event.target.value;
        setCurrency(value);
      },
      toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
        let scrollY = window.scrollY;
        if(this.isMenuOpen) {
          document.body.classList.add('noscroll');
          document.body.style.top = `-${scrollY}px`;
        } else {
          let scroll = document.body.style.top;
          document.body.classList.remove('noscroll');
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scroll || '0') * -1);
        }
        this.toggleSidecart(false);
        this.closeAllMegamenus();
      },

      toggleSidecart(show) {
        const drawerNowOpen = window.drawerFunctions.toggleDrawer('drawer_sidecart', show);
        if (drawerNowOpen) {
          window.analytics.cartView();
          this.closeAllMegamenus();
        }
      },

      toggleMinicart() {
        this.isMinicartOpen = !this.isMinicartOpen;
        this.isMenuOpen = false;
        if (this.isMinicartOpen) {
          var items = [];
          for (var i=0; i<this.cart.items.length; i++) {
            items.push({
              name: this.cart.items[i].title,
              sku: this.cart.items[i].sku,
              id: this.cart.items[i].product_id,
              price: this.cart.items[i].price / 100,
              brand: this.cart.items[i].vendor.replace("'", ''),
              variant: this.cart.items[i].variant_title.replace("'", ''),
              variant_id: this.cart.items[i].variant_id,
              quantity: this.cart.items[i].quantity,
              category: this.cart.items[i].product_type,
              total_discount: this.cart.items[i].total_discount,
              discounted_price: this.cart.items[i].discounted_price,
              discounts: this.cart.items[i].discounts,
            })
          }
        }
        this.closeAllMegamenus();
      },

      toggleMegamenu(parent) {
        if (parent.indexOf("__") == -1) {
          // If top level menu, close all others
          for (let menu in this.isMegamenuOpen) {
            if (menu != parent) this.isMegamenuOpen[menu] = false;
          }
        }

        this.isMegamenuOpen[parent] = !this.isMegamenuOpen[parent];
      },

      async focusMegamenu(parent, currentMenuLink, focusForward) {
        const SELECTOR_FOCUSABLE = `
          a[href]:not([href="javascript:"]), area[href], button:not([disabled]):not([aria-hidden]),
          input:not([disabled]):not([aria-hidden]):not([type="hidden"]),
          select:not([disabled]):not([aria-hidden]), textarea:not([disabled]):not([aria-hidden]),
          embed, iframe, object, [contenteditable], [tabindex]:not([tabindex^="-"])
        `;

        const menu = document.querySelector(`.megamenu[parent-item="${parent}"]`)

        const elements = menu.querySelectorAll(SELECTOR_FOCUSABLE);
        const firstElement = elements[0];
        const lastElement = elements[elements.length - 1];

        const menuItems = document.querySelectorAll('.menu.d-lg-flex .menu__item:not(.d-lg-none)');
        const firstMenuItem = menuItems[0];
        const lastMenuItem = menuItems[menuItems.length - 1];

        const currentMenuParent = currentMenuLink.parentElement;

        await nextTick(firstElement.focus())

        menu.addEventListener('keydown', async (e) => {
          if (e.shiftKey && e.keyCode === 9 && firstElement === this.activeElement) {
              e.preventDefault();
              await nextTick(currentMenuLink.focus())
              this.closeAllMegamenus()
          }
  
          if (e.keyCode === 9 && !e.shiftKey && lastElement === this.activeElement) {
            if (lastMenuItem !== currentMenuParent) {
              currentMenuLink.focus();
              this.closeAllMegamenus();
            }

            this.closeAllMegamenus()
          }
        })

        if (!focusForward && firstMenuItem !== currentMenuParent) {
          return;
        }

        if (!focusForward && firstMenuItem === currentMenuParent) {
          this.closeAllMegamenus()
          return;
        }
        
        await nextTick(firstElement.focus())
      },

      closeAllMegamenus() {
        for (let menu in this.isMegamenuOpen) {
          this.isMegamenuOpen[menu] = false;
        }
      },

      removeItem(item, index) {
        console.log("item", item, index);
        item.isLoading = true;
        Vue.set(this.cart.items, index, item);

        let data = {
          [item.id]: 0
        };

        console.log("reduced", data);

        axios
          .post("/cart/update.js", { updates: data })
          .then(response => {
            console.log("response", response.data);
            this.cart = response.data;
            Object.assign(window.theme.cart, this.cart);

            // get Compare at price
            this.cartLoaded = true;
          })
          .catch(function(error) {
            console.log(error);
            item.isLoading = false;
          });
      },

      async addToCart(payload, quantity = 1, productInfo = {}) {

        // Allow parameters to be passed in an object, or individually, to permit legacy implementations of addToCart 
        // while allowing new ones that identify product data for use in analytics.
        // NOTE: This whole payload thing is obsolete, replaced by cart.js.

        // Assume the first argument is not an object, for the legacy implementations.
        let variantId = payload;
        // If it is an object, reassign parameters to the payload properties, with the existing values as fallbacks.
        if (typeof payload === 'object') {
          // console.log('ADD TO CART:', 'WITH PAYLOAD', payload);
          ({ variantId, quantity = quantity, productInfo = productInfo = {} } = payload);
        } else {
          // console.log('ADD TO CART:', 'BY ID', payload);
        }

        if (!variantId) return;

        const newCart = await window.cartUtils.addOrChange(variantId, quantity, {

      });
        this.toggleSidecart(true);
        return newCart;
      },

      async clearAndAdd(...args) {
        // params here are just to pass straight through to addToCart

        window.spawnDialog(`Hey babe, in order to purchase tickets we have to remove everything from your bag before adding this item. Is that ok?`, 'clearCartConfirm', {
          'Cancel': undefined,
          'No': undefined,
          'Yes': async () => {
            await window.cartUtils.clearCart();
            await this.addToCart(...args);
          },
        });

        // const doIt = confirm('Adding this item will remove all the other things you have in your bag. Is that ok babe?');
        // if (!doIt) {
        //   return;
        // }

        // await window.cartUtils.clearCart();
        // return await this.addToCart(...args);
      },

      async explicitGroupAdd(explicitGroup, ...args) {
        const groupInCart = !!window.theme.cart.items.find(item => item.explicit_group === explicitGroup);
        if (!groupInCart && window.theme.cart.items.length > 0) {
          return await this.clearAndAdd(...args);
        }
        return await this.addToCart(...args);
      },

      getDiscountAmount: function(threshold, in_cart) {
        return threshold - in_cart;
      },

      updateCartQty: function(item, index, quantity) {
        var changeQuantity = quantity;
        quantity = item.quantity + quantity;

        // Don't allow more than 15 units to be added to cart
        if (quantity >= 15) {
          quantity = 15;
        }

        let data = {
          id: item.key,
          quantity: quantity
        };

        item.isLoading = true;

        Vue.set(this.cart.items, index, item);

        axios
          .post("/cart/change.js", data)
          .then(response => {
            this.cart = response.data;
            Object.assign(window.theme.cart, this.cart);

            let currentItem = filter(this.cart.items, function(cartItem) {
              return cartItem.key == item.key;
            });

            if (currentItem[0] && currentItem[0].quantity == item.quantity && currentItem[0].quantity == 15) {
              currentItem[0].message = "No more stock!";
              Vue.set(this.cart.items, index, currentItem[0]);
            }

            // get Compare at price
            this.cartLoaded = true;
          })
          .catch(function(error) {
            console.log(error);
            item.isLoading = false;
          })
          .finally(() => {
            item.isLoading = false;
          });
      },

      toggleMobileSearch() {
        setTimeout(() => {
          this.$refs.search.focus();
        }, 100);

        // console.log(1, 'toggleMobileSearch', this.isSearchOpen);
        this.isSearchOpen = !this.isSearchOpen;
      },

      closeSearchModal(e) {
        // console.log(2, 'closeSearchModal', this.isSearchOpen, e.target);

        if (!this.isSearchOpen || this.searchChanging) {
          // If the search modal is already closed, or, it's just been opened, ignore the close. 
          // It's only "changing" for a short time so this shouldn't cause any UX issues.
          return;
        }
        
        this.isSearchOpen = false;
      },

      openSearchModal(e) {
        // console.log(3, 'openSearchModal', this.isSearchOpen, e.target);
        
        this.isSearchOpen = !this.isSearchOpen;
        // console.log(this.isSearchOpen);
      },

      debouncedToggleSearchModal(e, open) {
        // console.log(4, 'debouncedToggleSearchModal', open, e.target);

        if (this.searchChanging) {
          return;
        }

        this.searchChanging = true;
        this.isSearchOpen = typeof open !== undefined ? open : !this.searchOpen;
        setTimeout(() => { this.searchChanging = false }, 200);
      },

      // set site information & geolocation settings
      setSiteInfo(){
          this.siteName = (Shopify.shop.includes('aus') || Shopify.shop.includes('dev')) ? "Australia" : "International";

          let userCountry = "Australia";
            if(Shopify.shop.includes('usa')){
                userCountry = "United States";
          }
          // if(this.getParameterByName("redirected")) {
          //   Cookie.remove('redirectAgain');
          // }
          // if(Cookie.get('userCountry')){
          //     if(Cookie.get('redirectAgain') == Shopify.shop){
          //         let destinationURL = (Shopify.shop == 'white-fox-boutique-usa.myshopify.com') ? 'whitefoxboutique.com.au' : "whitefoxboutique.com";
          //         let queryParameters = 'redirected=true&locced=true' + (window.theme.linkerParam ? '&' + window.theme.linkerParam: '');
          //         window.location.href = "https://"+destinationURL+document.location.pathname + (window.location.search ? window.location.search + '&' + queryParameters : '?' + queryParameters);
          //     }

          // }else{
          //     this.checkUserCountry();
          // }

      },
      /*
      redirectTo(url){
          
            // Set cookie so it will not show the popup next time;
            let userCountry = "Australia";
            if(url.includes('usa')){
                userCountry = "United States";
            }

            Cookie.set("userCountry", userCountry, {
              expires: 30,
              path: "/",
              sameSite: 'lax',
              secure:'true'
            });

            if(url != Shopify.shop){
                Cookie.set("redirectAgain", Shopify.shop, {
                  expires: 30,
                  path: "/",
                  sameSite: 'lax',
                  secure:'true'
                });
                let destinationURL = (Shopify.shop == 'white-fox-boutique-usa.myshopify.com') ? 'whitefoxboutique.com.au' : "whitefoxboutique.com";
                let queryParameters = 'redirected=true&locced=true' + (window.theme.linkerParam ? '&' + window.theme.linkerParam: '');
                window.location.href = "https://"+destinationURL+document.location.pathname + (window.location.search ? window.location.search + '&' + queryParameters : '?' + queryParameters);
            }else{
                $('#redirect-modal').removeClass('show');
                $('#redirect-modal').hide();
            }

        },
        */

        checkIfAnalyticsLoaded(limit) {
          if(limit == 15){
            return;
          }
          if (window.ga) {
            ga('create', 'UA-48511942-1');
            var that = this;
            ga(function(tracker) {
              var linkerParam = tracker.get('linkerParam');
              window.theme.linkerParam = linkerParam;
              // window.addEventListener('DOMContentLoaded',function () {
              //   $('.international_links').attr('href', $('.international_links').attr('href') + "&" + window.theme.linkerParam);
              // });
              that.setSiteInfo();
            });
          } else {
            limit++;
            var that = this;
            // Retry. Probably want to cap the total number of times you call this.
            setTimeout(function(){
              that.checkIfAnalyticsLoaded(limit);
            }, 500);
          }
        },

    },

    created() {
      document.addEventListener('focusin', this.focusChanged)

      this.checkIfAnalyticsLoaded(0);
      this.cart = window.theme.cart;
      this.cartLoaded = true;

      document.addEventListener('cart:refresh', e => {
        const { detail } = e;
        this.cart = detail;
        this.cartLoaded = true;
      });

      var that = this;
      $(document).on('click', '.product-item__image-block-variants .quick_add-link a:not(.out_of_stock)', async function(e) {
        e.preventDefault();
        var product_id = $(this).data('product-id');
        var variant_id = $(this).data('variant-id');
        var product_handle = $(this).data('product-handle');

        that.addToCart(variant_id, 1, {}, true);

        var title = $('.quick_add_title[data-product-id="' + product_id +  '"]');
        title.text("ADDED TO BAG!");
        setTimeout(function(){ title.text('QUICK ADD TO BAG:') }, 3000);
      });

      $(document).on('click', '.quick_add-toggle', function(e) {
        $(this).siblings('.product-item__image-block-variants-wrapper').toggleClass('_show');
      });


   
      $(document).on('click', '.bikini_product__add-to-cart', function(e) {
        e.preventDefault();

        var $form = $(e.target).closest('form.quick_add-link');
 

    
        var variant_id = $form.find('input#activeVariant').val();
        var product_id = $form.data('product-id');



        that.addToCart({
          variantId: variant_id,
          quantity: 1,
            
          
      });
  });
  
      // axios
      //   .get("/cart.js")
      //   .then(response => {
      //     console.log('minicart', response.data);
      //     this.cart = response.data;
      //     Object.assign(window.theme.cart, this.cart);
      //     this.cartLoaded = true;
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   })
      //   .finally(() => {
      //     // console.log('finally');
      //   });

        this.styleTagNodeList = document
        .querySelector(this.$options.el)
        .querySelectorAll("style");

      // console.log('Add ATC hook for Fast Simon');
      document.addEventListener('fs-custom-events-add-to-cart-response', event => {
        // console.log('FS EVENT HOOK', 'fs-custom-events-add-to-cart-response', event.detail);

        let { cart, item } = event.detail;

        if (!cart) {
          cart = event.detail;
        }

        window.cartUtils.refreshCart();
        this.toggleSidecart(true);
      });
    },

    computed: {

      getSiteLocation() {
            let us_visitors = ['NA','SA'];
            if(this.visitorInfo){
                return (us_visitors.includes(this.visitorInfo.continent_code)) ? "us" : 'au' ;
            }
      },

      totalSaving() {
        // The reason for if condition is not to show NaN
        if (this.OriginalTotalPrice > 0) {
          return this.OriginalTotalPrice - this.cart.total_price;
        } else {
          return 0;
        }
      },

      OriginalTotalPrice() {
        if (this.cartLoaded) {
          let original_total_price = 0;
          this.cart.items.forEach(item => {
            if (item.hasOwnProperty("compare_at_price")) {
              original_total_price =
                original_total_price + item.compare_at_price * item.quantity;
            } else {
              original_total_price =
                original_total_price + item.final_line_price;
            }
          });

          // The reason for if condition is not to show NaN
          if (!isNaN(original_total_price)) {
            return original_total_price;
          } else {
            return 0;
          }
        }
      }
    },

    mounted() {
      // set shop Currency
      // theme.liquid <input type="hidden" ref="shopCurrency" value="{{ shop.currency }}">
      this.shopCurrency = this.$refs.shopCurrency.value;

      for (var i = 0; i < this.styleTagNodeList.length; ++i){
        this.$el.appendChild(this.styleTagNodeList[i]);

      }

      window.freezeApp = this.freeze;
      window.overlayToggleApp = this.overlayToggle;
    }
  });
}

let ChallengePage = (window.location.pathname === 'challenge');

/*
 * Workaround for issue when Vue wraps the index template, admin cannot configure dynamic
 * sections from the theme customizer.
 * All elements with v-if or v-show directives will be hidden by default, add the attribute
 * "shopify-design-mode-show" to force show.
 * TODO: refactor to only apply to index template
 */
if (!Shopify.designMode && !ChallengePage) {
  // console.log(document.querySelector('head'));
  // document.querySelectorAll('style').forEach((style) => {
  //   console.log('style', style);
  //   document.querySelector('body').appendChild(style);
  // });

  document
    .querySelectorAll('script:not([type]):not([dont_move_me]), script[type="text/javascript"]:not([dont_move_me])')
    .forEach(script => {
      document.querySelector("body").appendChild(script);
    });

  initVueInstance();
} else {
  document.querySelectorAll("[v-cloak]").forEach(element => {
    element.removeAttribute("v-cloak");
  });
  document.querySelectorAll("[v-if], [v-show]").forEach(element => {
    if (!element.hasAttribute("shopify-design-mode-show")) {
      element.classList.toggle("d-none");
    }
  });
}

function iwishCheckColl() {
  if ($(".collection__wrap .iwishcheck").length > 0) {
    $(".collection__wrap .iwishcheck").each(function() {
      var iWishpId = $(this).data("product");
      var iWishvId = $(this).data("variant");
      if (isInWishlist(iWishpId.toString(), iWishvId.toString())) {
        $(this).addClass("iwishAdded");
      }
      $(this).removeClass("iwishcheck");
    });
  }
}

setTimeout(function() {
  iwishCheckColl();
}, 1000);

window.modalFunctions = {
  hide: (id) => {
    const modalEl = document.getElementById(id);
    const dismissedKey = `modalDismissed${ id }`;
    window.localStorage.setItem(dismissedKey, new Date().getTime());
    modalEl.classList.remove('show');
  },
  show: (id) => {
    const modalEl = document.getElementById(id);
    modalEl.classList.add('show');
  },
  toggle: (id) => {
    const modalEl = document.getElementById(id);
    if (modalEl.classList.contains('show')) {
      modalEl.classList.remove('show');
    } else {
      modalEl.classList.add('show');
    }
  },
  setAsDismissed: (id) => {
    const dismissedKey = `modalDismissed${ id }`;
    window.localStorage.setItem(dismissedKey, new Date().getTime());
  },
}

const dismissedParam = getParamByName('setModalAsDismissed');
if (dismissedParam) {
  window.modalFunctions.setAsDismissed(dismissedParam);
}

document.addEventListener('DOMContentLoaded', function() {
  const modals = Array.from(document.querySelectorAll('.modal'));
  modals.forEach(m => {
    const id = m.id;
    const closeButtons = Array.from(m.querySelectorAll('.modal_close'));
    closeButtons.forEach(b => {
      b.addEventListener('click', function(e) {
        window.modalFunctions.hide(id);
      });
    });

    m.addEventListener('click', function(e) {
      console.log(e);
      const isBackdrop = e.target.classList.contains('modal');
      if (!isBackdrop) {
        return false;
      }
      window.modalFunctions.hide(id);
    });
  });
});

  document.addEventListener('DOMContentLoaded', () => {
      let pdpWishListBtn = document.querySelector('.iwish-icon');
      if(pdpWishListBtn){
      pdpWishListBtn.addEventListener('click', ({ target }) => {
          window.analytics.addToWishList(target);
      });
    }
  });


// assign a region to form
// my thoughts are that we will retrieve this information by using window.location.href & .includes(".com.au") to determine the region
// another way if we wanted to control this logic through the theme is to use data-attributes in the HTML


let region = document.querySelector("body").getAttribute("data-store-code");
let conditional = ".com.au";
let url = window.location.href;
region = url.includes(conditional) ? "au" : region;

const makeUSInput = (birthdayField, region, container) => {
  if (region === "au") return;
  const placeholderMask = container.querySelector(
    ".placeholder_mask .placeholder"
  );
  // birthdayField.setAttribute("placeholder", "MM/DD/YYYY");
  birthdayField.setAttribute("title", "Birthday MM/DD/YYYY");
  placeholderMask.innerHTML = "MM/DD/YYYY";
  placeholderMask.setAttribute("data-placeholder", "MM/DD/YYYY");
};

const convertDate = (evt) => {
  const hiddenInput = document.getElementById("birth_date");
  let date = evt.target.value;
  hiddenInput.setAttribute(
    "value",
    date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
  );
  return date;
};

const addMask = (evt, container) => {
  const placeholderMask = container.querySelector(
    ".placeholder_mask .placeholder"
  );
  const childMask = container.querySelector(".child_mask");
  let date = evt.target.value;
  if (evt.inputType !== "deleteContentBackward") {
    childMask.innerText = "";
    childMask.classList.remove("remove_opacity");
    placeholderMask.classList.add("child_mask_removed");
    if (date.length === 3 || date.length === 6) {
      let filler = "";
      filler = evt.data == "/" ? (filler = "") : (filler = "/");  
      evt.target.value =
        date.substr(0, date.length - 1) + filler + date.substr(date.length - 1);
      let text = placeholderMask.innerText;
      let updateText = "";
          updateText = evt.data === "/" ? updateText = text.substring(1) : updateText = text.substring(2);
      placeholderMask.innerText = updateText;
      childMask.innerText = evt.target.value;
    } else if (date.length !== 3 || date.length !== 6){
      let text = placeholderMask.innerText;
      let updateText = text.substring(1);
      placeholderMask.innerText = updateText;
      childMask.innerText = evt.target.value;
    }
  } else {
    let originalText = placeholderMask.getAttribute("data-placeholder");
    const placeholderRemainder = originalText.slice(date.length);
    let updatedValue = `${date}${placeholderRemainder}`;

    let childString = childMask.innerText;
    childString = childString.slice(0, -1);
    childMask.innerText = childString;
    placeholderMask.innerText = updatedValue;
  }
};

const errorHandlingForBackSpacing = (evt, container) => {
  const placeholders = container.querySelectorAll(".placeholder_mask i");
  const region = document.querySelector("body").getAttribute("data-store-code");
  const birthday = region === "au" ? "DD/MM/YYYY" : "MM/DD/YYYY";
  const greeting = container.querySelector(".birthday_input").getAttribute("data-greeting");
  console.log(placeholders)
  if(evt.code === "Backspace" || evt.code === "Delete"){
    evt.target.value = "";
    placeholders[0].innerText = greeting;
    placeholders[0].classList.add("remove_opacity");
    placeholders[1].innerText = birthday;
    placeholders[1].classList.remove("child_mask_removed")
  }
}

const errorHandlingForPasting = (evt, container) => {
  if(evt.clipboardData){
    let paste = evt.clipboardData.getData('text');
    const placeholders = container.querySelectorAll(".placeholder_mask i");
    evt.target.value = "";
    placeholders[0].innerText = "";
    placeholders[0].classList.add("remove_opacity");
    placeholders[1].innerText = "";
    placeholders[1].classList.remove("child_mask_removed");
    if(paste.includes("/") !== true){
      for(let i = 0; i < paste.length; i++){
        if(i === 2 || i === 5){
          paste = paste.substring(0, i) + "/" + paste.substring(i);
        } 
      } 
    }

    evt.target.value = paste;
  }
}

const errorHandlingForCutting = (evt, container) => {
  const placeholders = container.querySelectorAll(".placeholder_mask i");
  const region = document.querySelector("body").getAttribute("data-store-code");
  const birthday = region === "au" ? "DD/MM/YYYY" : "MM/DD/YYYY";
  const greeting = container.querySelector(".birthday_input").getAttribute("data-greeting");
  evt.target.value = "";
  placeholders[0].innerText = greeting;
  placeholders[0].classList.add("remove_opacity");
  placeholders[1].innerText = birthday;
  placeholders[1].classList.remove("child_mask_removed")
}

const hasEmoji = (regExp, string) => {
  return regExp.test(string);
}


const detectEmojis = (evt, container) => {
  const string = evt.target.value;
  const regExp = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/;

  if(hasEmoji(regExp, string)){
    evt.target.value = string.replace(regExp, "");
  } else {
    addMask(evt, container);
  }
}

window.initMasking = () => {
  let birthdayFields = document.querySelectorAll('.birthday_input');
  Array.from(birthdayFields).forEach((element, index) => {
    const container = element.closest('._mask');

    if (!container) {
      return;
    }

    makeUSInput(element, region, container);

    element.addEventListener("input", (evt) => {
      detectEmojis(evt, container);
    });
    
    element.addEventListener("keydown", (evt) => {
      errorHandlingForBackSpacing(evt, container);
    });
    
    element.addEventListener("paste", (evt) => {
      errorHandlingForPasting(evt, container);
    });
    
    element.addEventListener("cut", (evt) => {
      errorHandlingForCutting(evt, container);
    });
    
    element.addEventListener("blur", (evt) => {
      const hiddenInput = document.getElementById("birth_date");
      let date = evt.target.value;
      console.log(region)
      region === "us" ? (date = convertDate(evt)) : hiddenInput.value = date;
    });
  });
}

window.initMasking(); 